import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle/apiHandle";

// Get all tickets
export const getAdminTickets = createAsyncThunk(
  "supportTickets/getAdminTickets",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append("status", filters.status);
      if (filters.priority) params.append("priority", filters.priority);
      if (filters.category) params.append("category", filters.category);

      const response = await apiHandle.get(`/admin/tickets?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.log("error from get tickets", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Get ticket by ID
export const getAdminTicketById = createAsyncThunk(
  "supportTickets/getAdminTicketById",
  async (ticketId, { rejectWithValue }) => {
    try {
      const response = await apiHandle.get(`/admin/tickets/${ticketId}`);
      return response.data;
    } catch (error) {
      console.log("error from get ticket by id", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Reply to ticket
export const adminReplyToTicket = createAsyncThunk(
  "supportTickets/adminReplyToTicket",
  async ({ ticketId, message }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/admin/tickets/${ticketId}/reply`, { message });
      return response.data;
    } catch (error) {
      console.log("error from reply to ticket", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Update ticket status
export const updateTicketStatus = createAsyncThunk(
  "supportTickets/updateTicketStatus",
  async ({ ticketId, status }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/admin/tickets/${ticketId}/status`, { status });
      return response.data;
    } catch (error) {
      console.log("error from update ticket status", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Assign ticket
export const assignTicket = createAsyncThunk(
  "supportTickets/assignTicket",
  async ({ ticketId, assigned_to }, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post(`/admin/tickets/${ticketId}/assign`, { assigned_to });
      return response.data;
    } catch (error) {
      console.log("error from assign ticket", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);
